export { default as AppTitle, Title } from "./Title";
export type { TitleProps, TitleSize } from "./Title";

export { default as AppDescription, Description } from "./Description";
export type { DescriptionProps, DescriptionSize } from "./Description";
